import cssUtil from 'gw-portals-util-js/CssUtil';
import templateStr from 'text!./pa-edit-vehicle.html';
import styles from './PAEditVehicle-hashed.scss';

export default ['VehicleImageLookupService', 'VinLookupService', 'VinLookupEnabled', '$q', '$filter', function (VehicleImageLookupService, VinLookupService, VinLookupEnabled, $q, $filter) {
    return {
        restrict: 'A',
        scope: {
            vehicle: '=',
            vehicleImageUrl: '=?',
            readonly: '='
        },
        template: cssUtil.hashTemplate(templateStr, styles),

        controller: ['$scope', function ($scope) {
            function resetForm() {
                $scope.years = [];
                $scope.errorMsg = '';
                $scope.showLoading = false;
                $scope.invalidVIN = null;

                var currentYear = new Date().getUTCFullYear();
                var OLDEST_CAR_YEAR = 1908;

                for (var i = currentYear; i > OLDEST_CAR_YEAR; i--) {
                    $scope.years.push(i);
                }
            }

            $scope.$watch('invalidVIN', function (newValue) {
                $scope.readonly = newValue === false;
                $scope.errorMsg = '';
            });

            $scope.lookupVIN = function () {
                if (VinLookupEnabled) {
                    $scope.invalidVIN = null;
                    if ($scope.vehicle.vin.value && $scope.vehicle.vin.value.length > 0) {
                        $scope.readonly = true;
                        $scope.showLoading = true;
                        $q.when(VinLookupService.autofillBasedOnVIN($scope.vehicle.vin.value), function (vehicleInfo) {
                            if (vehicleInfo && vehicleInfo.make && vehicleInfo.model && vehicleInfo.year) {
                                // Autofill with the returned data
                                $scope.invalidVIN = false;
                                $scope.vehicle.make.value = vehicleInfo.make;
                                $scope.vehicle.model.value = vehicleInfo.model;
                                $scope.vehicle.year.value = vehicleInfo.year;
                                $scope.errorMsg = '';
                            } else {
                                // The VIN does not return a match, VIN is invalid
                                $scope.invalidVIN = true;
                                $scope.vehicle.make.value = '';
                                $scope.vehicle.model.value = '';
                                $scope.vehicle.year = undefined;
                                $scope.vehicleImageUrl = undefined;
                            }
                            $scope.showLoading = false;
                        }, function () {
                            // Something has gone legitimately wrong, let the user input the data manually
                            $scope.errorMsg = $filter('translate')('quoteandbind.pa.directives.PAEditVehicle.errorMsg'); // POR-2061
                            $scope.readonly = false;
                            $scope.showLoading = false;
                            $scope.invalidVIN = null;
                        });
                    } else {
                        $scope.readonly = false;
                        $scope.errorMsg = '';
                        $scope.vehicle.make.value = '';
                        $scope.vehicle.model.value = '';
                        $scope.vehicle.year.value = undefined;
                    }
                }
            };

            $scope.$watchCollection('[vehicle.make.value, vehicle.model.value, vehicle.year.value]', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    if ($scope.vehicle.make.value && $scope.vehicle.model.value && $scope.vehicle.year.value) {
                        $q.when(VehicleImageLookupService.lookupPhoto($scope.vehicle.value).then(function (url) {
                            if (url) {
                                $scope.$applyAsync(function () {
                                    $scope.vehicleImageUrl = url;
                                });
                            } else {
                                $scope.$applyAsync(function () {
                                    $scope.vehicleImageUrl = undefined;
                                });
                            }
                        }));
                    }
                    $scope.errorMsg = '';
                }
            });

            resetForm();
            $scope.$on('update-form', function () {
                resetForm();
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/directives/pa-edit-vehicle/PAEditVehicle.js
// module id = 2175
// module chunks = 0